// ----------------------------------------------------------------------
export var Menu = function Menu(_ref) {
  var theme = _ref.theme;
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&$selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover
            }
          }
        }
      }
    }
  };
};